import { useContext, useMemo } from "react";
import LanguageContext from "../../Contexts/LangContext";
import { getTranslations } from "../../utils/lang";

const useLang = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLang must be used within a LanguageProvider");
  }
  const { lang, toggleLang } = context;
  const texts = useMemo(() => {
    return getTranslations(lang);
  }, [lang]);

  return { lang, toggleLang, texts, Rtl: lang == "ar" };
};

export default useLang;
